// PropertyPaymentsPage.js

import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import axios from 'axios';
import './PropertySearchResults.css'; // Reuse existing styles
import './PropertyPayments.css'; // Reuse existing styles
import PropertyInfo from './PropertyInfo'; // Import PropertyInfo component

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const TaxStatusPage = () => {
  const { taxid, taxyear } = useParams();
  const { dataProperty, dataClient } = useOutletContext();
  const [groupedPayments, setGroupedPayments] = useState(null);
  const [error, setError] = useState(null);
  const proxyUrl = process.env.REACT_APP_PROXY_URL;
  const isDev = process.env.REACT_APP_ENV === "development" ? true : false;

  const [hasLien, setHasLien] = useState(false);

  useEffect(() => {
    if (!dataClient || !dataClient.customer_number) return;

    const fetchData = async () => {
      try {
        const responsePaymentsDue = await apiClient.get(
          `/api/payments/due/${dataClient.customer_number}/${taxid}/${taxyear}`
        );

        // Get the payments data
        const paymentsData = Array.isArray(responsePaymentsDue.data.result)
        ? responsePaymentsDue.data.result
        : [];

        if (paymentsData.length === 0) {
          setGroupedPayments([]);     // no groups
          setHasLien(false);          // clear any lien flag
          return;                     // skip grouping & sorting
        }

        setHasLien(!!paymentsData[0].propertyTaxLien);

        // Group payments by PropertyTaxYear
        const grouped = paymentsData.reduce((acc, payment) => {
          const year = payment.propertyTaxYear;
          if (!acc[year]) {
            acc[year] = [];
          }
          acc[year].push(payment);
          return acc;
        }, {});

        // Sort each group from oldest to newest based on propertyTaxDate
        for (const year in grouped) {
          grouped[year] = grouped[year].slice().sort((a, b) => {
            const dateA = new Date(a.propertyTaxDate);
            const dateB = new Date(b.propertyTaxDate);
            return dateA - dateB; // Oldest to newest
          });
        }

        // Convert the grouped object into an array of [year, payments] pairs, sorted by year
        const groupedArray = Object.entries(grouped).sort((a, b) => b[0] - a[0]); // Sort years descending

        
        setGroupedPayments(groupedArray);
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [dataClient, taxid, taxyear]);

  if (error) return <div>Error: {error.message || error}</div>;

  if (!groupedPayments) {
    return <div>Loading payment status...</div>;
  }
  const formatDate = (dateStr) => {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return '';
    }

    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${month}/${day}/${year}`;
  };
  return (
    <div>
      <div>
      {/* Include the PropertyInfo component */}
      <PropertyInfo
        dataProperty={dataProperty}
        dataTax={[]} // Pass an empty array or adjust as needed
        proxyUrl={proxyUrl}
      />
      </div>
      {/* Clear floats if necessary */}
      <div style={{ clear: 'both' }}></div>
      {/* Payments Due Section */}
      <div  className="property-search-results">
      {groupedPayments.length > 0 ? (
        <div className="payments-due">
          {groupedPayments.map(([year, payments]) => (
            <div key={year} className="year-group">
              <h2 className="taxYearHeading">Tax Year: {year}</h2>
              <ul className="results-list">
              {payments.map((payment, index) => (
  <li key={index} className="result-item">
    {/* Left Column: Payment Details */}
    <div className="left-column">
      {payment.propertyTaxPaymentStatus === "ASSIGNMENT" ? (
        <div>
          <strong>Property is under Assignment for the tax date: {formatDate(payment.propertyTaxDate)}. Please contact your County Treasurer.</strong>
        </div>
      ) : (
        <>
          <div>
            <strong>Amount Due:</strong> ${payment.propertyTaxTotalAmount}
          </div>
          <div>
            <strong>Due Date:</strong>{' '}
            {new Date(payment.propertyTaxDate).toLocaleDateString()}
          </div>
          <div>
            <strong>Payment Type:</strong> {payment.propertyTaxPaymentType}
          </div>
          <div>
            <strong>Penalty:</strong> {payment.propertyTaxPenalty}
          </div>
          <div>
            <strong>Interest:</strong> {payment.propertyTaxInterest}
          </div>
          {/* Conditionally render APS and PTAP status */}
          {isDev && (
            <>
            <div>
              APS: {payment.propertyTaxAPSStatus ? "Yes" : "No"}
            </div>
            <div>
              PTAP: {payment.propertyTaxPTAPStatus ? "Yes" : "No"}
            </div>
            <div>
              ASSIGNMENT: {payment.propertyTaxAssignment ? "Yes" : "No"}
            </div>
            <div>
              Lien: {payment.propertyTaxLien ? "Yes" : "No"}
            </div>
            </>
          )}
        </>
      )}
    </div>

    {/* Right Column: Pay Button */}
    <div className="right-column">
      {payment.propertyTaxPaymentStatus === "PAID" ? (
        <span>PAID</span>
      ) : payment.propertyTaxPaymentStatus === "ASSIGNMENT" ? (
        <span>ASSIGNMENT</span>
      ) : (
        <span>DUE</span>
      )}
    </div>
  </li>
))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        <div>
          {hasLien ? (
            <div>A tax lien is attached to the property. Please contact your County Treasurer.</div>
          ) : (
            <div>No payments due.</div>
          )}
        </div>
      )}
      
      </div>
    </div>
  );
};

export default TaxStatusPage;
